import { PromiseBuilder_$ctor } from "./Promise.fs.js";

export const promise = PromiseBuilder_$ctor();

//# sourceMappingURL=PromiseImpl.fs.js.map
